import React, {useContext} from 'react';
import { Doughnut } from 'react-chartjs-2';
import { getColor } from 'helpers/utils';
import { chartJsDefaultTooltip } from 'helpers/chartjs-utils';
import AppContext from 'context/Context';

const PredictedCostChart = ({ efficiencyScore }) => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  const options = {
    tooltip: chartJsDefaultTooltip(),
    rotation: -90,
    circumference: '180',
    cutout: '80%',
    plugins: {
      legend: {
        display: false
      },
      tooltip: chartJsDefaultTooltip()
    }
  };
  const gaugeLabelPlugin = {
    id: 'gaugeLabelPlugin',
    afterDraw(chart) {
      const { ctx, chartArea } = chart;
      const meta = chart.getDatasetMeta(0);

      if (!meta?.data?.length) return;

      const arc = meta.data[0];
      const x = arc.x;
      const value = Math.round(chart.data.datasets[0].data[0]);
      // subir el texto hacia dentro de la media luna
      const y = chartArea.top + (chartArea.bottom - chartArea.top) * 0.58;

      ctx.save();
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      ctx.font = 'bold 45px "Open Sans", -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
      ctx.fillStyle = isDark ? 'white' :'#111827';
      ctx.fillText(value + '%', x, y);

      ctx.font = '16px "Open Sans", -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
      ctx.fillStyle = '#3b82f6';
      ctx.fillText('Efficiency Score', x, y + 33);

      ctx.restore();
    }
  };
  const data = {
    labels: ['Efficiency Score', 'Remaining'],
    datasets: [
      {
        data: [efficiencyScore, 100 - efficiencyScore],
        backgroundColor: [getColor('primary'), getColor('300')],
        borderColor: [getColor('primary'), getColor('300')]
      }
    ]
  };
  return (
    <div className="text-center" width="50%">
      <Doughnut data={data} plugins={[gaugeLabelPlugin]} options={options} width="112px" className="my-n5" />
    </div>
  );
};
export default PredictedCostChart;
